import React, { useEffect, useState } from "react";
import "./Coupon_Card.css";
import Green_Btn from "../common_btn/green_btn/Green_Btn";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { getCoupons } from '../../../features/home/homeSlice'
import { useDispatch, useSelector } from "react-redux";

const Coupon_Card = ({ val, data, showtc, handelSubmit }) => {
  const dispatch = useDispatch();
const [expanded, setExpanded] = useState(false);

  return (
    <section className="Coupon_Card">
      <div className="top_div">
        <div className="left_side">
          <img
            src="/assets/images/checkout/discount.png"
            className="discount_img"
          />
          <p className="coupon_code">{val?.name}</p>
        </div>
        <div className="apply_div">
          <Green_Btn btn_name="Apply" onClick={() => handelSubmit(val)} />
        </div>
      </div>

      <div className="content_text_div">
        <p className="main_text">
          {" "}
          Save ₹
          {val?.Discount_Type?.id === 2
            ? (
                ((data?.total_selling_price_gst || 0) * (val?.discount || 0)) /
                100
              ).toFixed(2)
            : parseFloat(val?.discount || 0).toFixed(2)}{" "}
          on this order!
        </p>

        <ul>
          <li className="point_text">
            {" "}
            Flat{" "}
            {val?.Discount_Type?.id === 2
              ? `${val?.discount}%`
              : val?.discount}{" "}
          </li>
          <li className="point_text">
            Valid on minimum purchase of ₹{val?.required_amount}{" "}
          </li>
          <li className="point_text">{val?.message}</li>
          <li className="point_text">
            {expanded
              ? val?.info
              : val?.info?.length > 50
              ? `${val.info.slice(0, 50)}...`
              : val?.info}

            {val?.info?.length > 50 && (
              <span
                className="read_more_text"
                onClick={() => setExpanded(!expanded)}
                style={{ cursor: "pointer", color: "#007bff" }}
              >
                {expanded ? " Read less" : " Read more..."}
              </span>
            )}
          </li>

          {/* <li className="point_text">
            {" "}
            {val?.info}
            <span className="read_more_text">Ream more...</span>
          </li> */}
        </ul>

        {showtc && (
          <div className="tc_div">
            <p className="tc_text">
              Terms & Conditions{" "}
              <FontAwesomeIcon icon={faAngleRight} className="arrow_icon" />
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Coupon_Card;
